import React, {Component} from "react";
import { Link } from 'react-router-dom';

import "../App.css";


class Source extends Component {
    render() {
        return (
            <p className="content">
                <img src="morehere.png" width="116" height="94" className="top_anno" alt="Click menu!"/>
                <p><strong>Welcome, learner!</strong></p>
                <p>This is where we post all of the latest information for the O'Reilly Media book
                    &nbsp;<em>Head First Android Development</em>,
                    so if you're looking for
                    <ul>
                        <li><Link to="source">source code from the book</Link></li>
                        <li><Link to="resources">images and other resources</Link>&nbsp;for building the apps,</li>
                        <li>or the
                            latest Android <Link to="twitter">news and blogs</Link></li>
                    </ul>
                    this is the place to be!</p>
                <p>And because Android development evolves faster than the printers can print books, we will
                    also be publishing free bonus material over the next few months to cover new technologies
                    as they appear.</p>
                <p>So stay tuned, and don't forget to
                    &nbsp;<a href="https://twitter.com/headfirstdroid">follow us on Twitter</a></p>
            </p>
        );
    }
}

export default Source;



// WEBPACK FOOTER //
// ./src/containers/Home.js